import { CircleDollarSign, Printer } from "lucide-react";
import { fmtTime } from "@/lib/datetime";

// Últimos cobros del turno — presentacional.
export const UltimosCobros = ({ ultimosCobros, reimprimirTicket, paperWidth }) => (
  <div data-testid="ultimos-cobros">
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-2">
        <CircleDollarSign className="h-4 w-4 text-[#FFCC00]" />
        <h3 className="font-display text-sm font-black uppercase tracking-wider">Últimos cobros del turno</h3>
      </div>
      {ultimosCobros.length > 0 && (
        <span className="text-[10px] font-bold uppercase tracking-wider text-white/40" data-testid="ultimos-cobros-count">{ultimosCobros.length}</span>
      )}
    </div>
    {ultimosCobros.length === 0 ? (
      <p className="text-white/30 text-xs py-6 text-center border border-white/10" data-testid="ultimos-cobros-empty">Aún no hay cobros en este turno.</p>
    ) : (
      <div className="border border-white/10 divide-y divide-white/5">
        {ultimosCobros.map((c) => (
          <div key={c.id_ticket} className="flex items-center justify-between px-3 py-2.5 hover:bg-white/5 transition-colors duration-150" data-testid={`cobro-row-${c.id_ticket}`}>
            <div className="flex items-center gap-3 min-w-0">
              <span className="font-display font-bold text-sm text-white/90 truncate">{c.folio_impreso}</span>
              <span className={`text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 border ${c.metodo_pago === "Efectivo" ? "text-[#34D399] border-[#34D399]/40" : "text-[#38BDF8] border-[#38BDF8]/40"}`}>{c.metodo_pago || "—"}</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-[10px] text-white/30 font-mono">{c.fecha_salida ? fmtTime(c.fecha_salida) : ""}</span>
              <span className="font-mono font-bold text-[#FFCC00]">${Number(c.total_pagado).toFixed(2)}</span>
              <button onClick={() => reimprimirTicket(c, paperWidth)} title="Reimprimir comprobante de pago"
                data-testid={`cobro-reimprimir-${c.id_ticket}`}
                className="btn-hard h-8 w-8 shrink-0 flex items-center justify-center bg-white/5 border border-white/20 hover:border-[#FFCC00] text-white/70 hover:text-[#FFCC00] transition-colors">
                <Printer className="h-4 w-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default UltimosCobros;
